export default __webpack_public_path__ + "static/media/help_img.8cc7b0cf.png";